import Api from "js/core/api";
import { AiMethods,
    AuthoringBlockType,
    ElementTextBlockPositionType, HeaderPositionType, ListStyleType,
    TextStyleType } from "common/constants";
import { uuid } from "js/core/utilities/utilities";
import { ConvertSlideToTemplate } from "js/editor/TemplateSwitcher/SwitchTemplateDialog";
import React from "react";
import { CreateItemForCollection } from "js/editor/AIGeneration/GenerateSlideModel";

export function DesignerBotIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 20 20" fill="currentColor" style={{ transform: "scale(.85)" }} >
            <path fillRule="evenodd" clipRule="evenodd" d="M10.8334 4.82669C11.5692 4.50521 12.0834 3.77101 12.0834 2.91671C12.0834 1.76611 11.1506 0.833374 10 0.833374C8.84945 0.833374 7.91671 1.76611 7.91671 2.91671C7.91671 3.77101 8.43091 4.50521 9.16671 4.82669V7.50004H5.33337C4.2288 7.50004 3.33337 8.39547 3.33337 9.50004V10.4167C1.95266 10.4167 0.833374 11.536 0.833374 12.9167C0.833374 14.2974 1.95266 15.4167 3.33337 15.4167V16.3334C3.33337 17.4379 4.2288 18.3334 5.33337 18.3334H14.6667C15.7713 18.3334 16.6667 17.4379 16.6667 16.3334V15.4167C18.0474 15.4167 19.1667 14.2974 19.1667 12.9167C19.1667 11.536 18.0474 10.4167 16.6667 10.4167V9.50004C16.6667 8.39547 15.7713 7.50004 14.6667 7.50004H10.8334V4.82669ZM14.5834 12.9167C14.5834 13.8372 13.8372 14.5834 12.9167 14.5834C11.9962 14.5834 11.25 13.8372 11.25 12.9167C11.25 11.9962 11.9962 11.25 12.9167 11.25C13.8372 11.25 14.5834 11.9962 14.5834 12.9167ZM7.08337 14.5834C8.00385 14.5834 8.75004 13.8372 8.75004 12.9167C8.75004 11.9962 8.00385 11.25 7.08337 11.25C6.1629 11.25 5.41671 11.9962 5.41671 12.9167C5.41671 13.8372 6.1629 14.5834 7.08337 14.5834Z" />
        </svg>
    );
}

export class AiGenerationController {
    static async GeneratePresentationOutline(description) {
        let props = {
            type: AiMethods.GENERATE_PRESENTATION_OUTLINE,
            description
        };

        const { response } = await Api.gpt.post(props);
        console.log(response);
        return response;
    }

    static async GenerateSlideFromOutline(slide) {
        let props = {
            type: AiMethods.GENERATE_SLIDE,
            ...slide
        };
        const { response } = await Api.gpt.post(props);
        console.log("------------------------------------------");
        console.log(`${slide.slideTitle} : ${slide.slideType}`);
        console.log(response);
        return response;
    }

    static async GenerateSlideFromPrompt(slideDescription) {
        let props = {
            type: AiMethods.GENERATE_SLIDE_TYPE,
            slideDescription,
        };
        const { response } = await Api.gpt.post(props);
        console.log("------------------------------------------");
        console.log(response);
        return response;
    }

    static async GenerateQuote(description) {
        let props = {
            type: AiMethods.GENERATE_QUOTE,
            description,
        };

        const { response } = await Api.gpt.post(props);
        return JSON.parse(response);
    }

    static async RewriteText(options) {
        let props = {
            type: AiMethods.REWRITE_TEXT,
            ...options
        };

        console.log("call ai", props);
        const { response } = await Api.gpt.post(props);
        console.log("ai response", response);
        return response.trim().replace(/^"(.*)"$/, "$1");
    }

    static async GenerateSummaryForSlide(canvas) {
        let props = {
            type: AiMethods.GENERATE_SUMMARY,
            slide_text: getPrimaryElementText(canvas)
        };

        const { response } = await Api.gpt.post(props);

        canvas.model.layout.elementTextBlockPosition = ElementTextBlockPositionType.TRAY;
        canvas.model.elements.elementTextBlock = {
            elementTextBlock: {
                blocks: [{
                    id: uuid(),
                    html: response,
                    type: AuthoringBlockType.TEXT,
                    textStyle: TextStyleType.TITLE
                }]
            }
        };
        canvas.updateCanvasModel(true);
    }

    static async GenerateImageForSlide(canvas) {
        let props = {
            type: AiMethods.GENERATE_IMAGE_KEYWORDS,
            slide_text: getPrimaryElementText(canvas)
        };

        const { response } = await Api.gpt.post(props);

        console.log(response);
    }

    static async GenerateTextSlide(canvas) {
        let props = {
            type: AiMethods.GENERATE_PARAGRAPHS,
            slide_text: getPrimaryElementText(canvas)
        };

        const { response } = await Api.gpt.post(props);
        console.log(response);

        await ConvertSlideToTemplate(canvas, "text");

        canvas.model.elements.primary.text.blocks = [];
        for (let para of response.split("\n")) {
            if (para !== "") {
                canvas.model.elements.primary.text.blocks.push({
                    id: uuid(),
                    html: para,
                    type: AuthoringBlockType.TEXT,
                    textStyle: TextStyleType.BODY
                });
            }
        }
        canvas.updateCanvasModel(false);
    }

    static async GenerateBulletSlide(canvas) {
        let props = {
            type: AiMethods.GENERATE_LIST,
            slide_title: getHeaderText(canvas),
            slide_text: getPrimaryElementText(canvas)
        };

        const { response } = await Api.gpt.post(props);
        console.log(response);

        await ConvertSlideToTemplate(canvas, "textlist");

        canvas.model.elements.primary.items = [{
            id: uuid(),
            text: {
                blocks: []
            }
        }];

        let bullets = JSON.parse(response);
        for (let item of bullets) {
            canvas.model.elements.primary.items[0].text.blocks.push({
                id: uuid(),
                html: item.title,
                type: AuthoringBlockType.TEXT,
                textStyle: TextStyleType.BULLET_LIST,
                listStyle: ListStyleType.BULLET,
                indent: 0
            });
            canvas.model.elements.primary.items[0].text.blocks.push({
                id: uuid(),
                html: item.description,
                type: AuthoringBlockType.TEXT,
                textStyle: TextStyleType.BULLET_LIST,
                listStyle: ListStyleType.TEXT,
                indent: 1
            });
        }

        await canvas.updateCanvasModel(false);

        canvas.getPrimaryElement().distributeBullets(2);
        canvas.updateCanvasModel(false);
    }

    static async GenerateNewItemForCollection(element) {
        let headerBlock = element.canvas.model.elements.header?.text.blocks.find(b => b.textStyle == TextStyleType.HEADING);

        let hasImage = element.itemCollection[0].hasOwnProperty("content_value");
        let existingItems = element.itemCollection.map(item => item.text.blocks.find(b => b.textStyle == TextStyleType.TITLE)?.html || "");

        let props = {
            type: AiMethods.GENERATE_ITEM,
            slideTitle: headerBlock ? headerBlock.html : "",
            existingItems: existingItems.join(","),
            needsImage: hasImage
        };

        const { response } = await Api.gpt.post(props);
        console.log(response);

        let item = await CreateItemForCollection(response);
        element.itemCollection.push(item);
        element.canvas.updateCanvasModel(true);
    }
}

function getTextFromElement(elementModel) {
    return elementModel.text.blocks.reduce((text, block) => text + block.html + " ", "");
}

function getHeaderText(canvas, type = "body") {
    let slideText = "";
    if (canvas.model.layout.headerPosition != HeaderPositionType.NONE) {
        slideText += getTextFromElement(canvas.model.elements.header);
    }

    return slideText;
}

function getPrimaryElementText(canvas) {
    let slideText = "";
    if (canvas.getPrimaryElement().isInstanceOf("CollectionElement")) {
        for (let item of canvas.getPrimaryElement().itemCollection) {
            slideText += getTextFromElement(item);
        }
    } else if (canvas.model.elements.primary.text) {
        return getTextFromElement(canvas.model.elements.primary);
    }

    return slideText;
}

